import { useEffect } from 'react';

import { MS_IN_S } from '../../../../constants';

export const useItemTracker = (durationMS: number, onFinished: () => void, activated = true) => {
  useEffect(() => {
    if (activated) {
      const countdownTimeout = setTimeout(() => {
        onFinished();
      }, durationMS * MS_IN_S);

      return () => {
        clearInterval(countdownTimeout);
      };
    }
    return;
  }, [durationMS, onFinished, activated]);
};
